var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcInfoBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    id: "svg29",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 2784",
    d: "M 12,23.900322 A 11.900322,11.900322 0 1 1 23.900322,12 11.900322,11.900322 0 0 1 12,23.900322 Z m 0,-2.379779 A 9.5205429,9.5205429 0 1 0 2.4794571,12 9.5205429,9.5205429 0 0 0 12,21.519116 Z M 10.81011,6.0491256 h 2.37978 v 2.3812058 h -2.37978 z m 0,4.7595584 h 2.37978 v 7.13363 h -2.37978 z",
    style: {
      strokeWidth: 1.42672
    },
    id: "path27"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfoBlack);
export default __webpack_public_path__ + "static/media/ic_info_black.cd0d6f19a74ae99fde948f07fd373ae7.svg";
export { ForwardRef as ReactComponent };